export var isEq=function(a,b){for(var c in b)if(a[c]!==b[c])return!1;return!0};
//# sourceMappingURL=isEq.js.map